document.addEventListener('DOMContentLoaded', () => {
  const page = document.body;
  const main = page.querySelector('main.accessibility-wrapper');

  if (!main) {
    return;
  }

  const groupedPage = Array.from(main.children).find((element) => (
    element.matches('.physmatics, .olympiad')
  ));
  const sectionContainer = groupedPage || main;
  const sections = Array.from(sectionContainer.children)
    .filter((element) => element.matches('section'))
    .slice(1);

  if (!sections.length) {
    return;
  }

  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer = null;
  let settingsObserver = null;

  const shouldSkipAnimation = () => (
    reducedMotionQuery.matches
    || page.dataset.accessibility === 'true'
    || page.dataset.noImages === 'true'
  );

  const reveal = (section) => {
    section.classList.remove('site-scroll-reveal--pending');
    section.classList.add('site-scroll-reveal--visible');
    observer?.unobserve(section);
  };

  const revealAll = () => {
    sections.forEach(reveal);
    observer?.disconnect();
  };

  if (shouldSkipAnimation() || !('IntersectionObserver' in window)) {
    return;
  }

  sections.forEach((section) => {
    section.classList.add('site-scroll-reveal', 'site-scroll-reveal--pending');
  });

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        reveal(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.05
  });

  sections.forEach((section) => observer.observe(section));

  settingsObserver = new MutationObserver(() => {
    if (shouldSkipAnimation()) {
      revealAll();
      settingsObserver.disconnect();
    }
  });

  settingsObserver.observe(page, {
    attributes: true,
    attributeFilter: ['data-accessibility', 'data-no-images']
  });

  const handleReducedMotionChange = () => {
    if (shouldSkipAnimation()) {
      revealAll();
      settingsObserver?.disconnect();
    }
  };

  if (typeof reducedMotionQuery.addEventListener === 'function') {
    reducedMotionQuery.addEventListener('change', handleReducedMotionChange, { once: true });
  } else {
    reducedMotionQuery.addListener(handleReducedMotionChange);
  }
});
